<div class="layout-inner">
  <h2 class="header">{{'app.landing.how.title' | translate}}</h2>
  <ul>
    <li>
      <div class="image">
        <img src="assets/img/Setup.svg" alt="{{'app.landing.how.setup' | translate}}">
      </div>
      <div class="content">
        <h3 class="content__small-header">{{'app.landing.how.setup' | translate}}</h3>
        <p>{{'app.landing.how.setup-text' | translate}}</p>
      </div>
    </li>
    <li>
      <div class="image">
        <img src="assets/img/Prep.svg" alt="{{'app.landing.how.prep' | translate}}">
      </div>
      <div class="content">
        <h3 class="content__small-header">{{'app.landing.how.prep' | translate}}</h3>
        <p>{{'app.landing.how.prep-text' | translate}}</p>
      </div>
    </li>
    <li>
      <div class="image">
        <img src="assets/img/Conversion.svg" alt="{{'app.landing.how.convert' | translate}}">
      </div>
      <div class="content">
        <h3 class="content__small-header">{{'app.landing.how.convert' | translate}}</h3>
        <p>{{'app.landing.how.convert-text' | translate}}</p>
      </div>
    </li>
    <li>
      <div class="image">
        <img src="assets/img/Ads_logo.svg" alt="{{'app.landing.how.complete' | translate}}">
      </div>
      <div class="content">
        <h3 class="content__small-header">{{'app.landing.how.complete' | translate}}</h3>
        <p>{{'app.landing.how.complete-text' | translate}}</p>
      </div>
    </li>
  </ul>
</div>
